module.exports = __webpack_public_path__ + "06_hair_silver.0ae7642f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/06_hair_silver.png
// module id = 4Olm
// module chunks = 0